"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupsWrapper = void 0;
var React = require("react");
var SinglePopupLifeCycle = /** @class */ (function (_super) {
    __extends(SinglePopupLifeCycle, _super);
    function SinglePopupLifeCycle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isOpen: false };
        return _this;
    }
    SinglePopupLifeCycle.prototype.componentDidMount = function () {
        if (this.props.isOpen === true) {
            this.setState({ isOpen: true });
        }
    };
    SinglePopupLifeCycle.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.isOpen === false) {
            return { isOpen: false };
        }
        return null;
    };
    SinglePopupLifeCycle.prototype.render = function () {
        var _a = this.props, currentPopup = _a.currentPopup, onClose = _a.onClose;
        return (React.createElement(currentPopup.ComponentClass, __assign({ isOpen: this.state.isOpen }, currentPopup.props, { onClose: function () {
                var params = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    params[_i] = arguments[_i];
                }
                return onClose(params);
            } })));
    };
    return SinglePopupLifeCycle;
}(React.Component));
var PopupsWrapper = /** @class */ (function (_super) {
    __extends(PopupsWrapper, _super);
    function PopupsWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopupsWrapper.prototype.componentDidMount = function () {
        var _this = this;
        this.props.popupManager.subscribeOnPopupsChange(function () { return _this.forceUpdate(); });
    };
    PopupsWrapper.prototype.onClose = function (currentPopup, params) {
        var _a;
        this.props.popupManager.close(currentPopup.guid);
        currentPopup.props &&
            currentPopup.props.onClose && (_a = currentPopup.props).onClose.apply(_a, params);
    };
    PopupsWrapper.prototype.render = function () {
        var _this = this;
        var popupManager = this.props.popupManager;
        return popupManager.popups.map(function (currentPopup) { return (React.createElement(SinglePopupLifeCycle, { currentPopup: currentPopup, key: currentPopup.guid, isOpen: currentPopup.isOpen, onClose: function (params) { return _this.onClose(currentPopup, params); } })); });
    };
    return PopupsWrapper;
}(React.Component));
exports.PopupsWrapper = PopupsWrapper;
//# sourceMappingURL=PopupsWrapper.js.map